<template>
	<!--  行-->
	<div>
		<div class="file_line">
			<span class="content_pulldown" @click="pulldown" :style="{'margin-left':(treeIndex*5)+'px'}">
				<!--默认向右，如果pulldown是false则改变src-->
				<!--如果不是文件夹则不显示向右-->
				<img :src="is_pulldown?right:box_checked_grey" v-if="model.isFolder" />
			</span>

			<span
				class="content_right"
				:style="{'margin-left':(treeIndex*5)+'px'}"
				@click="threeCheckStatus"
			>
				<img :src="box_to_check" v-show="model.three_check_status == 'no'" />
				<img :src="box_checked" v-show="model.three_check_status == 'yes'" />
				<img :src="box_half_checked" v-show="model.three_check_status == 'half'" />
			</span>

			<span class="content_file_icon" :style="{'margin-left':(treeIndex*2)+'px'}">
				<img :src="box_small_file_folder" v-if="model.isFolder" />
				<img :src="box_filetype" v-if="!model.isFolder" />
				<!--        <i v-show="!model.isFolder">{{model.name.substring(model.name.lastIndexOf('.')+1)}}</i>-->
			</span>

			<span
				class="content_name"
				@click="getChild"
				:style="{'margin-left':(treeIndex*2)+'px'}"
				:title="model.name"
			>{{ model.name }}</span>

			<span
				class="content_type"
				v-if="!model.isFolder"
			>{{model.name.substring(model.name.lastIndexOf('.')+1)}}</span>
			<span class="content_type" v-if="model.isFolder"></span>
			<span class="content_size" v-if="!model.isFolder">{{common.formatSize(model.size)}}</span>
			<span class="content_size" v-if="model.isFolder"></span>
			<span class="content_status" v-if="model.state == '0'">等待下载</span>
			<span class="content_status" v-if="model.state == '1'">正在下载</span>
			<span class="content_status" v-if="model.state == '2'">下载成功</span>
			<span class="content_status" v-if="model.state == '3'">下载失败</span>
			<span class="content_status" v-if="!model.state"></span>
			<!--      <span class="content_status" v-if="model.isFolder"></span>-->
		</div>
		<!--子文件-->
		<items
			v-show="isShow"
			v-for="(item, index) in model.child"
			:model="item"
			:key="index"
			:treeIndex="treeIndex+1"
		></items>
	</div>
</template>

<script>
import common from "../../../common/common";
export default {
	name: "items",
	data: function () {
		return {
			common: common,
			child_ids: [],
			// three_check_status:'yes',//
			is_pulldown: true,
			isShow: false,
			box_filetype: require("../assets/box_filetype.png"),
			box_small_file_folder: require("../assets/box_small_file_folder.png"),
			box_checked_grey: require("../assets/box_checked_grey.png"),
			right: require("../assets/box_right.png"),
			box_checked: require("../assets/box_checked.png"),
			box_half_checked: require("../assets/box_half_checked.png"),
			box_to_check: require("../assets/box_to_check.png"),
		};
	},
	props: ["model", "treeIndex"],
	computed: {},
	watch: {},
	methods: {
		// 是否展示子文件
		getChild: function () {
			let _that = this;
			if (_that.model.child) {
				_that.isShow = !_that.isShow;
				_that.is_pulldown = !_that.is_pulldown;
			}
		},
		pulldown: function () {
			let _that = this;
			if (_that.model.child) {
				_that.isShow = !_that.isShow;
				_that.is_pulldown = !_that.is_pulldown;
			}
		},
		getChildIdsRecursion: function (tree) {
			let _that = this;
			for (let index = 0; index < tree.length; index++) {
				if (tree[index].id == 0 || tree[index].id) {
					_that.child_ids.push(tree[index].id);
				}
				if (tree[index].child) {
					_that.getChildIdsRecursion(tree[index].child);
				}
			}
		},
		threeCheckStatus: function () {
			let _that = this;
			if (
				_that.model.isFolder &&
				(_that.model.three_check_status == "half" ||
					_that.model.three_check_status == "no")
			) {
				//获取儿子们的id
				_that.child_ids = [];
				_that.getChildIdsRecursion(_that.model.child);

				_that.ids = JSON.parse(
					JSON.stringify(_that.$store.state.editTaskBox.ids)
				);
				//合并
				console.log("_that.child_ids", _that.child_ids);

				let arr = common.mergeArray(_that.ids, _that.child_ids);
				//放到全局
				_that.$store.state.editTaskBox.ids = arr;
			} else if (
				_that.model.isFolder &&
				_that.model.three_check_status == "yes"
			) {
				// 获取儿子们的id
				_that.child_ids = [];
				_that.getChildIdsRecursion(_that.model.child);

				_that.ids = JSON.parse(
					JSON.stringify(_that.$store.state.editTaskBox.ids)
				);

				//删除
				for (let index = 0; index < _that.child_ids.length; index++) {
					_that.ids.splice(
						_that.ids.indexOf(_that.child_ids[index]),
						1
					);
				}

				//放到全局
				_that.$store.state.editTaskBox.ids = _that.ids;
			}

			//精准勾选
			if (
				(_that.model.id == 0 || _that.model.id) &&
				_that.model.three_check_status == "yes"
			) {
				console.log(11);
				_that.$store.state.editTaskBox.ids.splice(
					_that.$store.state.editTaskBox.ids.indexOf(_that.model.id),
					1
				);
			} else if (
				(_that.model.id == 0 || _that.model.id) &&
				_that.model.three_check_status == "no"
			) {
				_that.$store.state.editTaskBox.ids.push(_that.model.id);
			}
		},
	},
	mounted: function () {
		// //格式化文件大小
		// if(this.model.size){
		//   this.model.size = common.formatSize(this.model.size);
		// }
	},
};
</script>

<style lang="less" scoped>
.file_line {
	margin-top: 3px;
	display: flex;
	height: 18px;
	line-height: 18px;
	width: 100%;

	span {
		width: 75px;
	}
	.content_pulldown {
		width: 10px;
		height: 10px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.content_right,
	.content_file_icon {
		width: 16px;
		height: 16px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.content_size,
	.content_status,
	.content_type {
		text-align: center;
		//align-self: end;
	}

	//.content_type{
	//  //width: 40px;
	//  margin-left: 5px;
	//}

	//.content_file_icon{
	//  position: relative;
	//  i{
	//    left: 1px;
	//    position: absolute;
	//    font-size: 12px;
	//    color: white;
	//    transform: scale(0.6);
	//    transform-origin: left center;
	//  }
	//}

	.content_name {
		//margin-left: 0 !important;
		//width: 240px;
		//max-width: 240px;
		//padding-left: 10px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		flex: 1;
	}
}
</style>